import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

import { trackException } from '@fora-monorepo/webapp-analytics';
import {
  EmployeeWithReportedPayrollViewModel,
  PayrollDetailsFileViewModel,
  PayrollHistoryViewModel,
  ReportedPayrollsRequestInput,
  ReportingPeriodViewModel,
} from '@fora-monorepo/employer-my-pages-common/types';

import { envConfig } from '../../config';
import { createThunkError } from '../utils';
import { mockEmployeesWithReportedPayroll, mockPayHistory, mockReportingPeriods } from './mocks/mockPayHistoryList';

export const getPayHistory = createAsyncThunk(
  'getPayrollHistory',
  async (data: ReportedPayrollsRequestInput, thunkAPI) => {
    if (envConfig.mockDataFrontend) {
      await new Promise(resolve => setTimeout(resolve, 500));

      return mockPayHistory;
    }

    const payload = {
      ...data,
    };

    return axios
      .post(`${envConfig.bffBaseUri}/payroll-history/reported-payroll`, payload)
      .then(res => {
        const payrollHistory = res.data as PayrollHistoryViewModel;
        return payrollHistory;
      })
      .catch(err => {
        trackException(err);
        return thunkAPI.rejectWithValue(createThunkError('Could not get payroll history', err));
      });
  }
);

export const getEmployeesWithReportedPayroll = createAsyncThunk(
  'getEmployeesWithReportedPayroll',
  async ({ partnerNumberOrganization }: { partnerNumberOrganization: string }, thunkAPI) => {
    if (envConfig.mockDataFrontend) {
      await new Promise(resolve => setTimeout(resolve, 500));

      const mockdata = mockEmployeesWithReportedPayroll.largeAmount.slice(0, 1000);
      return mockdata;
      // return mockEmployeesWithReportedPayroll.standard;
    }

    return axios
      .post(`${envConfig.bffBaseUri}/payroll-history/employees-with-reported-payroll`, {
        partnerNumberOrganization: partnerNumberOrganization,
      })
      .then(res => {
        if (res.status === 200) {
          const employeesWithReportedPayroll = res.data as EmployeeWithReportedPayrollViewModel[];

          return employeesWithReportedPayroll;
        } else {
          throw new Error('Failed to fetch');
        }
      })
      .catch(err => {
        trackException(err);
        console.error('API error', err);
        return thunkAPI.rejectWithValue(createThunkError('Could not employees with reported payroll', err));
      });
  }
);

export const getReportingPeriods = createAsyncThunk(
  'getReportingPeriods',
  async ({ partnerNumberOrganization }: { partnerNumberOrganization: string }, thunkAPI) => {
    if (envConfig.mockDataFrontend) {
      await new Promise(resolve => setTimeout(resolve, 500));

      return mockReportingPeriods;
    }

    return axios
      .post(`${envConfig.bffBaseUri}/payroll/reporting-periods`, {
        partnerNumberOrganization: partnerNumberOrganization,
      })
      .then(res => {
        if (res.status === 200) {
          const reportingPeriods = res.data as ReportingPeriodViewModel[];

          return reportingPeriods;
        }
      })
      .catch(err => {
        trackException(err);
        return thunkAPI.rejectWithValue(createThunkError('Could not get dates for pay history', err));
      });
  }
);

export const createPayHistoryCSV = createAsyncThunk(
  'getPayHistoryCSV',
  async (payload: ReportedPayrollsRequestInput, thunkAPI) => {
    if (envConfig.mockDataFrontend) {
      await new Promise(resolve => setTimeout(resolve, 500));

      return;
    }

    return axios
      .post(`${envConfig.bffBaseUri}/payroll-history/download/reported-payroll`, payload)
      .then(res => {
        if (res.status === 200) {
          const payHistoryCSV = res.data as PayrollDetailsFileViewModel;
          return payHistoryCSV;
        } else if (res.status === 204) {
          console.error(`CSV returned 204 no content`);
        }
      })
      .catch(err => {
        trackException(err);
        return thunkAPI.rejectWithValue(createThunkError('Could not create pay history CSV', err));
      });
  }
);
